import { Icon } from "@chakra-ui/react";
const DotsMenuIcon = () => {
  return (
    <>
      <Icon
        xmlns="http://www.w3.org/2000/svg"
        width="4"
        height="4"
        viewBox="0 0 16 4"
      >
        <path
          id="dots-horizontal"
          d="M16,12a2,2,0,1,1,2,2,2,2,0,0,1-2-2m-6,0a2,2,0,1,1,2,2,2,2,0,0,1-2-2M4,12a2,2,0,1,1,2,2A2,2,0,0,1,4,12Z"
          transform="translate(-4 -10)"
          fill="#54667a"
        />
      </Icon>
    </>
  );
};
export default DotsMenuIcon;
